module.exports = __webpack_public_path__ + "img/drobnaratka.51241031.png";